import React from "react";
import { TextField, InputAdornment } from "@material-ui/core";
import SearchIcon from "@material-ui/icons/Search";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  searchBar: {
    background: "#FFFFFF",
    "& .MuiOutlinedInput-root": {
      borderRadius: 28,
      transition: "box-shadow 0.2s ease",
      "& fieldset": {
        borderColor: "rgba(0, 0, 0, 0.12)",
        transition: "border-color 0.2s ease",
      },
      "&:hover fieldset": {
        borderColor: "rgba(233, 58, 36, 0.35)",
      },
      "&.Mui-focused fieldset": {
        borderColor: theme.palette.primary.main,
        borderWidth: 1.5,
      },
      "&.Mui-focused": {
        boxShadow: "0 0 0 3px rgba(233, 58, 36, 0.08)",
        borderRadius: 28,
      },
    },
    "& .MuiInputLabel-outlined": {
      "&.Mui-focused": {
        color: theme.palette.primary.main,
      },
    },
    "& .MuiInputAdornment-root svg": {
      color: "rgba(0, 0, 0, 0.35)",
      width: 18,
      height: 18,
    },
  },
}));

const SearchBar = ({ label, handleChange }) => {
  const classes = useStyles();

  return (
    <TextField
      className={classes.searchBar}
      label={label}
      variant="outlined"
      fullWidth
      onChange={handleChange}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon />
          </InputAdornment>
        ),
      }}
    />
  );
};

export default SearchBar;
